import { ChangeDetectorRef, Component, Input, ViewChild } from '@angular/core';
import { ImageCropperComponent } from 'app/shared/ui/ngx-image-cropper/image-cropper.component';
import { ImageCroppedEvent } from 'app/shared/ui/ngx-image-cropper/interfaces/image-cropped-event.interface';
import { OverlayRef } from 'app/shared/ui/overlays';
import { fileFromEvent, isValidImage } from 'app/shared/utils';
import { UiModule } from '../ui';


@Component({
    selector: 'app-file-resize-modal',
    imports: [
        ImageCropperComponent,
        UiModule,
    ],
    styles: [
        `
        .image-preview {
            max-width: 100%;
            border: 1px solid lightgrey;
        }

        .hide-true {
            height: 0px;
        }

        .hide-false {
            height: auto;
        }
        `,
    ],
    template: `
        <ui-modal size="1300">
            <modal-header>
                Resize Image
            </modal-header>
            <modal-body>
                @if (!loading) {
                    <div class="row">
                        <div class="col-5">
                            <h3>Please adjust image</h3>
                            <div class="alert alert-info small">
                                <i class="fa fa-info-circle" aria-hidden="true"></i>
                                The image crop aspect ratio is fixed to best fit the branding space.
                            </div>
                            <div>
                                <ol>
                                    <li>Drag the corners to change the size of the cropping area.</li>
                                    <li>Move around the cropping area by dragging the selection.</li>
                                </ol>
                            </div>
                            <button class="btn btn-primary" (click)="switchContain()">
                                <img [src]="'/assets/images/' + (contain ? 'compress.svg' : 'expand.svg')" height="16">
                                {{ contain ? 'Adjust to crop part of image' : 'Adjust to include whole image' }}
                            </button>
                            <div class="hide-{{ cropperLoading }} mt-3" >
                                <image-cropper
                                    [imageChangedEvent]="imageChangedEvent"
                                    [maintainAspectRatio]="true"
                                    [aspectRatio]="aspectRatio"
                                    [format]="'jpeg'"
                                    [resizeToWidth]="maxWidth"
                                    [onlyScaleDown]="true"
                                    [containWithinAspectRatio]="contain"
                                    (imageLoaded)="hideCropperLoading()"
                                    (imageStartedLoading)="showCropperLoading()"
                                    (imageCropped)="imageCropped($event)">
                                </image-cropper>
                            </div>
                            @if (cropperLoading) {
                                <ui-block-loading></ui-block-loading>
                            }
                        </div>
                        @if (croppedImage) {
                            <div class="col-7">
                                <h3>Preview your current selection</h3>
                                <img alt="" [src]="croppedImage.base64" class="image-preview">
                            </div>
                        }
                    </div>
                }
                @else {
                    <ui-block-loading>Loading image...</ui-block-loading>
                }
            </modal-body>
            <modal-footer>
                <button class="btn btn-secondary mr-auto" (click)="close()">Cancel</button>
                <button class="btn btn-success" (click)="save()">Save</button>
            </modal-footer>
        </ui-modal>
    `,
})
export class FileResizeModalComponent {

    @ViewChild(ImageCropperComponent) imageCropper: ImageCropperComponent;

    imageChangedEvent: any = '';

    croppedImage: ImageCroppedEvent;

    loading = true;

    cropperLoading = false;

    contain = false;

    fileEvent: any = '';

    @Input() aspectRatio: number;

    @Input() maxWidth: number;

    @Input('uploadEvent')
    set uploadEvent(event: any) {
        this.onFileUploadEvent(event);
    }

    constructor(private overlayRef: OverlayRef, private cdr: ChangeDetectorRef) {}

    onFileUploadEvent(event: any) {
        this.fileEvent = event;
        const file = fileFromEvent(event);
        isValidImage(file).then(() => {
            this.loading = false;
            this.fileChangeEvent(event);
            this.cdr.detectChanges();
        }).catch(() => {
            this.overlayRef.result.error({
                'message': 'Invalid file, please use different one or contact support',
            });
            this.overlayRef.dismiss('wrong image type');
        });
    }

    save() {
        if (!this.croppedImage || !this.croppedImage.file) {
            return;
        }
        // .file is actually Blob -> convert to File
        this.overlayRef.close(new File([this.croppedImage.file], 'output.jpeg'));
    }

    fileChangeEvent(event: any) {
        this.imageChangedEvent = event;
    }

    imageCropped(image: ImageCroppedEvent) {
        this.croppedImage = image;
    }

    close() {
        this.overlayRef.dismiss();
    }

    switchContain() {
        this.contain = !this.contain;
        this.imageChangedEvent = null;
        this.cdr.detectChanges();
        this.fileChangeEvent(this.fileEvent);
    }

    showCropperLoading() {
        this.cropperLoading = true;
    }

    hideCropperLoading() {
        this.cropperLoading = false;
    }
}
